import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux'

import * as actions from './actions'

const searchResults = handleActions({
  [actions.searchListingSuccess]: (state, action) => action.payload
}, {articles: []})

const renderSearchTable = handleActions({
  [actions.searchListing]: (state, action) => action.payload.trim().length
}, false)

const searchInput = handleActions({
  [actions.searchListing]: (state, action) => action.payload
}, '')

const isSearchPending = handleActions({
  [combineActions(
    actions.searchListingPending,
    actions.searchListing
  )]: () => true,
  [combineActions(
    actions.searchListingSuccess,
    actions.searchListingFailed
  )]: () => false,
}, false)

export default combineReducers({
  searchResults,
  renderSearchTable,
  searchInput,
  isSearchPending
})